<template>
  <div>
    <h1>Grid 栅格</h1>
    <p class="page-desc">24 栅格系统。</p>

    <demo-viewer title="基础用法" :code="JCYF" desc="水平排列的布局。">
      <k-row>
        <k-col class="demo-col" span="4"><div class="block">&nbsp;</div></k-col>
        <k-col class="demo-col" span="4"><div class="block">&nbsp;</div></k-col>
        <k-col class="demo-col" span="4"><div class="block">&nbsp;</div></k-col>
        <k-col class="demo-col" span="4"><div class="block">&nbsp;</div></k-col>
        <k-col class="demo-col" span="4"><div class="block">&nbsp;</div></k-col>
        <k-col class="demo-col" span="4"><div class="block">&nbsp;</div></k-col>
      </k-row>
    </demo-viewer>

    <demo-viewer
      title="分栏间隔"
      :code="FLJG"
      desc="通过给 row 添加 gutter 属性，可以给下属的 col 添加间距。"
    >
      <k-row gutter="16">
        <k-col class="demo-col" span="6"><div class="block">&nbsp;</div></k-col>
        <k-col class="demo-col" span="6"><div class="block">&nbsp;</div></k-col>
        <k-col class="demo-col" span="6"><div class="block">&nbsp;</div></k-col>
        <k-col class="demo-col" span="6"><div class="block">&nbsp;</div></k-col>
      </k-row>
    </demo-viewer>

    <demo-viewer title="分栏偏移" :code="FLPY" desc="支持偏移指定的栏数。">
      <k-row gutter="16">
        <k-col class="demo-col" span="6"><div class="block">&nbsp;</div></k-col>
        <k-col class="demo-col" span="6"><div class="block">&nbsp;</div></k-col>
        <k-col class="demo-col" span="6" offset="6"
          ><div class="block">&nbsp;</div></k-col
        >
      </k-row>
    </demo-viewer>

    <demo-viewer
      title="响应式"
      :code="XYS"
      desc="参照了 Bootstrap 的 响应式设计，预设了五个响应尺寸：xs、sm、md、lg 和 xl。"
    >
      <k-row gutter="16">
        <k-col class="demo-col" span="6" :md="{ span: 2 }"
          ><div class="block">&nbsp;</div></k-col
        >
        <k-col class="demo-col" span="6" :md="{ span: 10 }"
          ><div class="block">&nbsp;</div></k-col
        >
        <k-col class="demo-col" span="6" :md="{ span: 10 }"
          ><div class="block">&nbsp;</div></k-col
        >
        <k-col class="demo-col" span="6" :md="{ span: 2 }"
          ><div class="block">&nbsp;</div></k-col
        >
      </k-row>
    </demo-viewer>

    <table class="doc-table">
      <caption>
        <h3>Row属性 props</h3>
      </caption>
      <thead>
        <tr>
          <th>参数</th>
          <th>说明</th>
          <th>类型</th>
          <th>可选值</th>
          <th>默认值</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>gutter</td>
          <td>栅格间隔(px)</td>
          <td>number|String</td>
          <td>-</td>
          <td>0</td>
        </tr>
        <tr>
          <td>align</td>
          <td>flex 布局下的水平排列方式</td>
          <td>String</td>
          <td>center, left, right</td>
          <td>left</td>
        </tr>
      </tbody>
    </table>

    <table class="doc-table">
      <caption>
        <h3>Col属性 props</h3>
      </caption>
      <thead>
        <tr>
          <th>参数</th>
          <th>说明</th>
          <th>类型</th>
          <th>可选值</th>
          <th>默认值</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>span</td>
          <td>栅格占据的列数</td>
          <td>number|String</td>
          <td>-</td>
          <td>24</td>
        </tr>
        <tr>
          <td>offset</td>
          <td>栅格左侧的间隔格数</td>
          <td>String</td>
          <td>-</td>
          <td>0</td>
        </tr>
        <tr>
          <td>xs</td>
          <td>小于576px 响应式栅格数或者栅格属性对象</td>
          <td>object (例如： {span: 4, offset: 4})</td>
          <td>-</td>
          <td>-</td>
        </tr>
        <tr>
          <td>sm</td>
          <td>介于576px和768px的响应式栅格数或者栅格属性对象</td>
          <td>object (例如： {span: 4, offset: 4})</td>
          <td>-</td>
          <td>-</td>
        </tr>
        <tr>
          <td>md</td>
          <td>介于768x和992px的响应式栅格数或者栅格属性对象</td>
          <td>object (例如： {span: 4, offset: 4})</td>
          <td>-</td>
          <td>-</td>
        </tr>
        <tr>
          <td>lg</td>
          <td>介于992px和1200px的响应式栅格数或者栅格属性对象</td>
          <td>object (例如： {span: 4, offset: 4})</td>
          <td>-</td>
          <td>-</td>
        </tr>
        <tr>
          <td>xl</td>
          <td>大于1200px的响应式栅格数或者栅格属性对象</td>
          <td>object (例如： {span: 4, offset: 4})</td>
          <td>-</td>
          <td>-</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      JCYF: `
  <k-row>
    <k-col span="4"> </k-col>
    <k-col span="4"> </k-col>
    <k-col span="4"> </k-col>
    <k-col span="4"> </k-col>
    <k-col span="4"> </k-col>
    <k-col span="4"> </k-col>
  </k-row>
      `,
      FLJG: `
  <k-row gutter="16">
    <k-col span="6"> </k-col>
    <k-col span="6"> </k-col>
    <k-col span="6"> </k-col>
    <k-col span="6"> </k-col>
  </k-row>
      `,
      FLPY: `
  <k-row gutter="16">
    <k-col span="6"> </k-col>
    <k-col span="6"> </k-col>
    <k-col span="6" offset="6"> </k-col>
  </k-row>
      `,
      XYS: `
  <k-row gutter="16">
    <k-col span="6" :md="{ span: 2 }"> </k-col>
    <k-col span="6" :md="{ span: 10 }"> </k-col>
    <k-col span="6" :md="{ span: 10 }"> </k-col>
    <k-col span="6" :md="{ span: 2 }"> </k-col>
  </k-row>
      `
    };
  }
};
</script>
<style lang="less" scoped>
.demo-col {
  & > div.block {
    color: #778aaf;
    text-align: center;
    background-color: #e1e4ea;
    padding: 10px;
  }

  &:nth-child(odd) {
    & > div.block {
      background-color: #d3d7e0;
    }
  }
}
</style>
